export default __webpack_public_path__ + "static/media/architecture.837095ce.png";